var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"straw-box"},[_c('input',{attrs:{"type":"color","id":"strawInput"}}),_c('img',{staticClass:"imgs",attrs:{"src":require("@/assets/img/straw.png")}})])
}]

export { render, staticRenderFns }